export const olAlertConstant = {
    OL_ADDED : "OL_ADDED",
    OL_FETCHING : "OL_FETCHING",
    OL_DATA : "OL_DATA",
}

